<div class="item" [class.selected]="selected()" (click)="select.emit(value())">
    <ng-content></ng-content>
</div>
